// extracted by mini-css-extract-plugin
export var blue = "_1x-h";
export var brand = "_1x-d";
export var darkGrey = "_1x-g";
export var disabled = "_1x-6";
export var disabledSubtle = "_1x-7";
export var error = "_1x-8";
export var green = "_1x-i";
export var grey = "_1x-f";
export var icon = "_1x-0";
export var inherit = "_1x-c";
export var lightGrey = "_1x-e";
export var orange = "_1x-k";
export var pink = "_1x-m";
export var primary = "_1x-1";
export var purple = "_1x-n";
export var quaternary = "_1x-4";
export var quinary = "_1x-5";
export var red = "_1x-l";
export var secondary = "_1x-2";
export var success = "_1x-b";
export var tertiary = "_1x-3";
export var warning = "_1x-9";
export var warningSecondary = "_1x-a";
export var white = "_1x-o";
export var yellow = "_1x-j";